import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Pricing() {
    const { user, refresh } = useAuth();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        api.get("/payments/plans").then((r) => setPlans(r.data.plans || []));
    }, []);

    const checkout = async (lookup_key) => {
        if (!user) {
            toast.error("Please log in first");
            return;
        }
        setLoading(lookup_key);
        try {
            const { data } = await api.post("/payments/checkout", {
                lookup_key,
                origin_url: window.location.origin,
            });
            window.location.href = data.checkout_url;
        } catch (e) {
            toast.error("Checkout failed");
            setLoading(null);
        }
    };

    return (
        <div className="mx-auto max-w-7xl px-6 py-16">
            <div className="mx-auto max-w-2xl text-center">
                <div className="overline mb-3 text-primary">Pricing</div>
                <h1 className="font-display text-5xl font-semibold tracking-tight">Unlock the full CRMA vault.</h1>
                <p className="mt-4 text-muted-foreground">Choose the plan that fits your study runway.</p>
            </div>

            <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
                {plans.map((p) => {
    const highlight = p.lookup_key === "yearly";
                    return (
                        <div key={p.lookup_key} className={highlight ? "tracing-border p-[2px]" : ""}>
                            <div className={`h-full ${highlight ? "rounded-md" : "border border-border"} bg-card p-8`} data-testid={`plan-${p.lookup_key}`}>
                                {highlight && <div className="overline mb-4 inline-block rounded-full bg-primary/15 px-3 py-1 text-primary">Best value</div>}
                                <h3 className="font-display text-2xl font-semibold">{p.name}</h3>
                                <div className="mt-6 flex items-baseline gap-2">
                                    <span className="font-display text-5xl font-semibold">${(p.amount / 100).toFixed(0)}</span>
                                    <span className="text-sm text-muted-foreground">{p.recurring ? `per ${p.recurring}` : "one-time"}</span>
                                </div>
                                <ul className="mt-6 space-y-3 text-sm">
                                    {["Full question bank access", "Practice + Exam simulator", "Performance analytics", "Bookmarks", "Free future additions"].map((f) => (
                                        <li key={f} className="flex items-start gap-2">
                                            <CheckCircle weight="fill" size={16} className="mt-0.5 text-primary" /> {f}
                                        </li>
                                    ))}
                                </ul>
                                <Button
                                    onClick={() => checkout(p.lookup_key)}
                                    disabled={loading === p.lookup_key || user?.premium}
                                    className={`mt-8 w-full ${highlight ? "bg-primary text-primary-foreground hover:bg-primary/90" : ""}`}
                                    variant={highlight ? "default" : "outline"}
                                    data-testid={`buy-${p.lookup_key}`}
                                >
                                    {user?.premium ? "Already premium" : loading === p.lookup_key ? "Redirecting…" : "Choose plan"}
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
